import React from 'react'
import { Link } from 'react-router-dom'

function RetourCourt() {
  return (
    <div>
    <Link to='/court'><button style={{margin: "20px 0px", padding: "10px", width: "200px", backgroundColor:"red", border: "none", borderRadius: "10px"}}>RETOUR</button></Link>
    </div>
  )
}

export default RetourCourt